import React from 'react';
import { CommonPageStep, SignupPageStep } from '..';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { CreateParentAccount } from './createParentAccount';
import { CreateParentProfile } from './createParentProfile';
import { YourChildAge } from './yourChildAge';
import { useAppSelector } from '../../store/hooks';
import {
  selectAppAuthentication,
  selectAppPageStep,
  selectAppStateData,
  setAppPageStep,
} from '../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../store/store';

export const SignUp = (): JSX.Element => {
  // Redux
  const pageStep = useAppSelector(selectAppPageStep);
  const authenticationData = useAppSelector(selectAppAuthentication);
  const appState = useAppSelector(selectAppStateData);

  // Page functions
  const storeUserSessionInfo = (): void => {
    const sessionInfoString = JSON.stringify({ ...authenticationData });
    window.localStorage.setItem('bigbang_session_info', sessionInfoString);
  };

  React.useEffect(() => {
    outsideComponentDispatch(
      setAppPageStep(SignupPageStep.CREATE_PARENT_ACCOUNT),
    );
  }, []);

  React.useEffect(() => {
    if (authenticationData) {
      storeUserSessionInfo();
    }
  }, [authenticationData]);

  return (
    <React.Fragment>
      {pageStep === CommonPageStep.ENTRY ? <Navigate to={`/Entry`} /> : null}
      {pageStep === CommonPageStep.LOGIN ? <Navigate to={`/Login`} /> : null}
      {authenticationData?.token ? <Navigate to={`/SUBSCRIPTION`} /> : null}
      {pageStep === SignupPageStep.CREATE_PARENT_ACCOUNT ? (
        <CreateParentAccount />
      ) : null}
      {pageStep === SignupPageStep.CREATE_PARENT_PROFILE ? (
        <CreateParentProfile />
      ) : null}
      {pageStep === SignupPageStep.YOUR_CHILD_AGE ? <YourChildAge /> : null}
    </React.Fragment>
  );
};
